import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

import {
  // JoinUs,
  OurDoctors,
  OurServices,
  Testimonial,
  Blog,
} from "components";

import {
  WaveLightInfoSection,
  HowWaveLightWorks,
  StepsSection,
  VisionHeroSection,
  FaqSection,
  Banner,
} from "./components";
import faqsSection from "./data/faqs";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is WaveLight Plus bladeless LASIK surgery?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "WaveLight Plus is an AI-guided bladeless LASIK surgery that maps over 22,000 data points on your cornea to deliver a fully personalised laser vision correction surgery. It is FDA approved and performed at Amrit Hospitals, Chennai.",
      },
    },
    {
      "@type": "Question",
      name: "Is WaveLight Plus a safe eye power correction surgery?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. WaveLight Plus is a safe and FDA-approved eye power correction surgery. It is one of the most trusted forms of refractive eye surgery available today, helping patients achieve clear vision with high precision.",
      },
    },
    {
      "@type": "Question",
      name: "Can WaveLight Plus permanently remove my specs?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. WaveLight Plus is an advanced specs removal surgery that helps eligible patients reduce or eliminate dependence on glasses and contact lenses by permanently reshaping the cornea.",
      },
    },
    {
      "@type": "Question",
      name: "How is WaveLight Plus different from standard LASIK?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Unlike standard LASIK, WaveLight Plus uses AI-powered 3D eye mapping and ray tracing technology to create a personalised treatment plan for each eye. This advanced laser eye surgery provides highly precise vision correction outcomes.",
      },
    },
    {
      "@type": "Question",
      name: "How long does laser vision correction surgery take?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "WaveLight Plus laser vision correction surgery takes less than 15 seconds per eye. The complete procedure, including preparation, is usually finished within 30 minutes, allowing patients to return home the same day.",
      },
    },
    {
      "@type": "Question",
      name: "Who is a candidate for refractive eye surgery with WaveLight Plus?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Adults with stable vision prescription, adequate corneal thickness, and conditions such as myopia, hyperopia, or astigmatism may be suitable candidates. A comprehensive eye evaluation is required to confirm eligibility.",
      },
    },
    {
      "@type": "Question",
      name: "What is the recovery time after WaveLight Plus surgery?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Most patients notice significantly improved vision within 24 hours after WaveLight Plus bladeless LASIK surgery and can quickly resume daily activities. Complete visual stabilisation generally occurs within one to two weeks.",
      },
    },
  ],
};

const WaveLightPlus = () => {
  return (
    <Box>
      <Helmet>
        <title></title>
        <meta
          name="description"
          content="Get bladeless LASIK surgery in Chennai with AI-guided WaveLight Plus technology. Advanced laser eye surgery for eye power correction — 98% achieve 20/20 vision. Book your free consultation at Amrit Hospitals today."
        />
        <meta name="keywords" content="bladeless LASIK surgery" />
        <meta
          name="title"
          content="Bladeless LASIK Surgery in Chennai | WaveLight Plus – Amrit Hospitals"
        />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <Banner />
      <WaveLightInfoSection />
      <HowWaveLightWorks />
      <StepsSection />
      <VisionHeroSection />

      {/* FAQ Section */}
      <FaqSection faqsSection={faqsSection} />
    </Box>
  );
};

export default WaveLightPlus;